var cov_8fog4h7k9 = function () {
  var path = "/Users/spana/SHEIN/shineout/src/Cascader/Result.tsx",
      hash = "0da91e262c1686dc070813aa3e7bfaa6dae486d7",
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = "__coverage__",
      coverageData = {
    path: "/Users/spana/SHEIN/shineout/src/Cascader/Result.tsx",
    statementMap: {
      "0": {
        start: {
          line: 29,
          column: 18
        },
        end: {
          line: 33,
          column: 15
        }
      },
      "1": {
        start: {
          line: 31,
          column: 8
        },
        end: {
          line: 31,
          column: 33
        }
      },
      "2": {
        start: {
          line: 34,
          column: 18
        },
        end: {
          line: 38,
          column: 15
        }
      },
      "3": {
        start: {
          line: 36,
          column: 8
        },
        end: {
          line: 36,
          column: 30
        }
      },
      "4": {
        start: {
          line: 39,
          column: 2
        },
        end: {
          line: 55,
          column: 3
        }
      },
      "5": {
        start: {
          line: 77,
          column: 4
        },
        end: {
          line: 77,
          column: 16
        }
      },
      "6": {
        start: {
          line: 78,
          column: 4
        },
        end: {
          line: 80,
          column: 5
        }
      },
      "7": {
        start: {
          line: 82,
          column: 4
        },
        end: {
          line: 82,
          column: 58
        }
      },
      "8": {
        start: {
          line: 83,
          column: 4
        },
        end: {
          line: 83,
          column: 48
        }
      },
      "9": {
        start: {
          line: 84,
          column: 4
        },
        end: {
          line: 84,
          column: 60
        }
      },
      "10": {
        start: {
          line: 85,
          column: 4
        },
        end: {
          line: 85,
          column: 52
        }
      },
      "11": {
        start: {
          line: 86,
          column: 4
        },
        end: {
          line: 86,
          column: 48
        }
      },
      "12": {
        start: {
          line: 87,
          column: 4
        },
        end: {
          line: 87,
          column: 46
        }
      },
      "13": {
        start: {
          line: 91,
          column: 22
        },
        end: {
          line: 91,
          column: 32
        }
      },
      "14": {
        start: {
          line: 92,
          column: 4
        },
        end: {
          line: 92,
          column: 52
        }
      },
      "15": {
        start: {
          line: 93,
          column: 27
        },
        end: {
          line: 93,
          column: 37
        }
      },
      "16": {
        start: {
          line: 94,
          column: 4
        },
        end: {
          line: 96,
          column: 5
        }
      },
      "17": {
        start: {
          line: 95,
          column: 6
        },
        end: {
          line: 95,
          column: 102
        }
      },
      "18": {
        start: {
          line: 100,
          column: 4
        },
        end: {
          line: 100,
          column: 29
        }
      },
      "19": {
        start: {
          line: 104,
          column: 22
        },
        end: {
          line: 104,
          column: 32
        }
      },
      "20": {
        start: {
          line: 105,
          column: 4
        },
        end: {
          line: 105,
          column: 54
        }
      },
      "21": {
        start: {
          line: 106,
          column: 4
        },
        end: {
          line: 106,
          column: 62
        }
      },
      "22": {
        start: {
          line: 106,
          column: 35
        },
        end: {
          line: 106,
          column: 62
        }
      },
      "23": {
        start: {
          line: 110,
          column: 32
        },
        end: {
          line: 110,
          column: 42
        }
      },
      "24": {
        start: {
          line: 111,
          column: 4
        },
        end: {
          line: 113,
          column: 5
        }
      },
      "25": {
        start: {
          line: 112,
          column: 6
        },
        end: {
          line: 112,
          column: 28
        }
      },
      "26": {
        start: {
          line: 114,
          column: 4
        },
        end: {
          line: 114,
          column: 26
        }
      },
      "27": {
        start: {
          line: 118,
          column: 4
        },
        end: {
          line: 118,
          column: 22
        }
      },
      "28": {
        start: {
          line: 122,
          column: 4
        },
        end: {
          line: 122,
          column: 22
        }
      },
      "29": {
        start: {
          line: 126,
          column: 32
        },
        end: {
          line: 126,
          column: 42
        }
      },
      "30": {
        start: {
          line: 127,
          column: 4
        },
        end: {
          line: 127,
          column: 79
        }
      },
      "31": {
        start: {
          line: 131,
          column: 55
        },
        end: {
          line: 131,
          column: 65
        }
      },
      "32": {
        start: {
          line: 132,
          column: 4
        },
        end: {
          line: 144,
          column: 5
        }
      },
      "33": {
        start: {
          line: 133,
          column: 6
        },
        end: {
          line: 133,
          column: 42
        }
      },
      "34": {
        start: {
          line: 133,
          column: 36
        },
        end: {
          line: 133,
          column: 42
        }
      },
      "35": {
        start: {
          line: 134,
          column: 6
        },
        end: {
          line: 143,
          column: 7
        }
      },
      "36": {
        start: {
          line: 135,
          column: 8
        },
        end: {
          line: 135,
          column: 24
        }
      },
      "37": {
        start: {
          line: 136,
          column: 13
        },
        end: {
          line: 143,
          column: 7
        }
      },
      "38": {
        start: {
          line: 137,
          column: 8
        },
        end: {
          line: 137,
          column: 24
        }
      },
      "39": {
        start: {
          line: 138,
          column: 13
        },
        end: {
          line: 143,
          column: 7
        }
      },
      "40": {
        start: {
          line: 139,
          column: 8
        },
        end: {
          line: 139,
          column: 36
        }
      },
      "41": {
        start: {
          line: 140,
          column: 21
        },
        end: {
          line: 140,
          column: 119
        }
      },
      "42": {
        start: {
          line: 141,
          column: 8
        },
        end: {
          line: 141,
          column: 31
        }
      },
      "43": {
        start: {
          line: 142,
          column: 8
        },
        end: {
          line: 142,
          column: 26
        }
      },
      "44": {
        start: {
          line: 148,
          column: 4
        },
        end: {
          line: 148,
          column: 38
        }
      },
      "45": {
        start: {
          line: 148,
          column: 32
        },
        end: {
          line: 148,
          column: 38
        }
      },
      "46": {
        start: {
          line: 149,
          column: 4
        },
        end: {
          line: 149,
          column: 31
        }
      },
      "47": {
        start: {
          line: 150,
          column: 4
        },
        end: {
          line: 150,
          column: 31
        }
      },
      "48": {
        start: {
          line: 151,
          column: 4
        },
        end: {
          line: 151,
          column: 22
        }
      },
      "49": {
        start: {
          line: 155,
          column: 15
        },
        end: {
          line: 155,
          column: 44
        }
      },
      "50": {
        start: {
          line: 156,
          column: 21
        },
        end: {
          line: 156,
          column: 55
        }
      },
      "51": {
        start: {
          line: 157,
          column: 4
        },
        end: {
          line: 157,
          column: 21
        }
      },
      "52": {
        start: {
          line: 157,
          column: 15
        },
        end: {
          line: 157,
          column: 21
        }
      },
      "53": {
        start: {
          line: 158,
          column: 4
        },
        end: {
          line: 158,
          column: 52
        }
      },
      "54": {
        start: {
          line: 159,
          column: 4
        },
        end: {
          line: 161,
          column: 5
        }
      },
      "55": {
        start: {
          line: 160,
          column: 6
        },
        end: {
          line: 160,
          column: 27
        }
      },
      "56": {
        start: {
          line: 165,
          column: 29
        },
        end: {
          line: 165,
          column: 39
        }
      },
      "57": {
        start: {
          line: 167,
          column: 37
        },
        end: {
          line: 167,
          column: 105
        }
      },
      "58": {
        start: {
          line: 169,
          column: 4
        },
        end: {
          line: 179,
          column: 31
        }
      },
      "59": {
        start: {
          line: 171,
          column: 8
        },
        end: {
          line: 177,
          column: 10
        }
      },
      "60": {
        start: {
          line: 179,
          column: 19
        },
        end: {
          line: 179,
          column: 30
        }
      },
      "61": {
        start: {
          line: 183,
          column: 4
        },
        end: {
          line: 185,
          column: 5
        }
      },
      "62": {
        start: {
          line: 184,
          column: 6
        },
        end: {
          line: 184,
          column: 29
        }
      },
      "63": {
        start: {
          line: 186,
          column: 29
        },
        end: {
          line: 186,
          column: 39
        }
      },
      "64": {
        start: {
          line: 187,
          column: 4
        },
        end: {
          line: 187,
          column: 22
        }
      },
      "65": {
        start: {
          line: 191,
          column: 47
        },
        end: {
          line: 191,
          column: 57
        }
      },
      "66": {
        start: {
          line: 192,
          column: 22
        },
        end: {
          line: 192,
          column: 110
        }
      },
      "67": {
        start: {
          line: 194,
          column: 4
        },
        end: {
          line: 198,
          column: 5
        }
      },
      "68": {
        start: {
          line: 196,
          column: 6
        },
        end: {
          line: 196,
          column: 72
        }
      },
      "69": {
        start: {
          line: 200,
          column: 4
        },
        end: {
          line: 200,
          column: 15
        }
      },
      "70": {
        start: {
          line: 217,
          column: 53
        },
        end: {
          line: 217,
          column: 63
        }
      },
      "71": {
        start: {
          line: 219,
          column: 4
        },
        end: {
          line: 227,
          column: 5
        }
      },
      "72": {
        start: {
          line: 220,
          column: 6
        },
        end: {
          line: 224,
          column: 7
        }
      },
      "73": {
        start: {
          line: 221,
          column: 8
        },
        end: {
          line: 221,
          column: 41
        }
      },
      "74": {
        start: {
          line: 223,
          column: 8
        },
        end: {
          line: 223,
          column: 64
        }
      },
      "75": {
        start: {
          line: 226,
          column: 6
        },
        end: {
          line: 226,
          column: 37
        }
      },
      "76": {
        start: {
          line: 229,
          column: 4
        },
        end: {
          line: 229,
          column: 25
        }
      },
      "77": {
        start: {
          line: 229,
          column: 14
        },
        end: {
          line: 229,
          column: 25
        }
      },
      "78": {
        start: {
          line: 230,
          column: 17
        },
        end: {
          line: 230,
          column: 42
        }
      },
      "79": {
        start: {
          line: 231,
          column: 4
        },
        end: {
          line: 246,
          column: 5
        }
      },
      "80": {
        start: {
          line: 250,
          column: 43
        },
        end: {
          line: 250,
          column: 53
        }
      },
      "81": {
        start: {
          line: 251,
          column: 17
        },
        end: {
          line: 251,
          column: 42
        }
      },
      "82": {
        start: {
          line: 252,
          column: 4
        },
        end: {
          line: 263,
          column: 5
        }
      },
      "83": {
        start: {
          line: 267,
          column: 89
        },
        end: {
          line: 267,
          column: 99
        }
      },
      "84": {
        start: {
          line: 268,
          column: 4
        },
        end: {
          line: 279,
          column: 5
        }
      },
      "85": {
        start: {
          line: 283,
          column: 44
        },
        end: {
          line: 283,
          column: 54
        }
      },
      "86": {
        start: {
          line: 284,
          column: 4
        },
        end: {
          line: 286,
          column: 5
        }
      },
      "87": {
        start: {
          line: 285,
          column: 6
        },
        end: {
          line: 285,
          column: 31
        }
      },
      "88": {
        start: {
          line: 287,
          column: 4
        },
        end: {
          line: 300,
          column: 5
        }
      },
      "89": {
        start: {
          line: 304,
          column: 48
        },
        end: {
          line: 304,
          column: 58
        }
      },
      "90": {
        start: {
          line: 305,
          column: 4
        },
        end: {
          line: 305,
          column: 60
        }
      },
      "91": {
        start: {
          line: 305,
          column: 49
        },
        end: {
          line: 305,
          column: 60
        }
      },
      "92": {
        start: {
          line: 306,
          column: 22
        },
        end: {
          line: 306,
          column: 31
        }
      },
      "93": {
        start: {
          line: 308,
          column: 4
        },
        end: {
          line: 312,
          column: 5
        }
      },
      "94": {
        start: {
          line: 316,
          column: 72
        },
        end: {
          line: 316,
          column: 82
        }
      },
      "95": {
        start: {
          line: 317,
          column: 18
        },
        end: {
          line: 317,
          column: 62
        }
      },
      "96": {
        start: {
          line: 317,
          column: 41
        },
        end: {
          line: 317,
          column: 61
        }
      },
      "97": {
        start: {
          line: 318,
          column: 17
        },
        end: {
          line: 318,
          column: 43
        }
      },
      "98": {
        start: {
          line: 319,
          column: 4
        },
        end: {
          line: 322,
          column: 5
        }
      },
      "99": {
        start: {
          line: 320,
          column: 25
        },
        end: {
          line: 320,
          column: 31
        }
      },
      "100": {
        start: {
          line: 321,
          column: 6
        },
        end: {
          line: 321,
          column: 71
        }
      },
      "101": {
        start: {
          line: 321,
          column: 32
        },
        end: {
          line: 321,
          column: 71
        }
      },
      "102": {
        start: {
          line: 323,
          column: 16
        },
        end: {
          line: 323,
          column: 93
        }
      },
      "103": {
        start: {
          line: 325,
          column: 4
        },
        end: {
          line: 327,
          column: 5
        }
      },
      "104": {
        start: {
          line: 326,
          column: 6
        },
        end: {
          line: 326,
          column: 36
        }
      },
      "105": {
        start: {
          line: 328,
          column: 4
        },
        end: {
          line: 328,
          column: 58
        }
      },
      "106": {
        start: {
          line: 330,
          column: 4
        },
        end: {
          line: 330,
          column: 16
        }
      },
      "107": {
        start: {
          line: 334,
          column: 85
        },
        end: {
          line: 334,
          column: 95
        }
      },
      "108": {
        start: {
          line: 335,
          column: 18
        },
        end: {
          line: 335,
          column: 36
        }
      },
      "109": {
        start: {
          line: 336,
          column: 19
        },
        end: {
          line: 336,
          column: 38
        }
      },
      "110": {
        start: {
          line: 337,
          column: 20
        },
        end: {
          line: 337,
          column: 38
        }
      },
      "111": {
        start: {
          line: 338,
          column: 29
        },
        end: {
          line: 338,
          column: 51
        }
      },
      "112": {
        start: {
          line: 339,
          column: 4
        },
        end: {
          line: 362,
          column: 5
        }
      }
    },
    fnMap: {
      "0": {
        name: "Item",
        decl: {
          start: {
            line: 18,
            column: 9
          },
          end: {
            line: 18,
            column: 13
          }
        },
        loc: {
          start: {
            line: 28,
            column: 30
          },
          end: {
            line: 56,
            column: 1
          }
        },
        line: 28
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 30,
            column: 6
          },
          end: {
            line: 30,
            column: 7
          }
        },
        loc: {
          start: {
            line: 30,
            column: 18
          },
          end: {
            line: 32,
            column: 7
          }
        },
        line: 30
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 35,
            column: 6
          },
          end: {
            line: 35,
            column: 7
          }
        },
        loc: {
          start: {
            line: 35,
            column: 12
          },
          end: {
            line: 37,
            column: 7
          }
        },
        line: 35
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 76,
            column: 2
          },
          end: {
            line: 76,
            column: 3
          }
        },
        loc: {
          start: {
            line: 76,
            column: 51
          },
          end: {
            line: 88,
            column: 3
          }
        },
        line: 76
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 90,
            column: 2
          },
          end: {
            line: 90,
            column: 3
          }
        },
        loc: {
          start: {
            line: 90,
            column: 22
          },
          end: {
            line: 97,
            column: 3
          }
        },
        line: 90
      },
      "5": {
        name: "(anonymous_5)",
        decl: {
          start: {
            line: 99,
            column: 2
          },
          end: {
            line: 99,
            column: 3
          }
        },
        loc: {
          start: {
            line: 99,
            column: 61
          },
          end: {
            line: 101,
            column: 3
          }
        },
        line: 99
      },
      "6": {
        name: "(anonymous_6)",
        decl: {
          start: {
            line: 103,
            column: 2
          },
          end: {
            line: 103,
            column: 3
          }
        },
        loc: {
          start: {
            line: 103,
            column: 25
          },
          end: {
            line: 107,
            column: 3
          }
        },
        line: 103
      },
      "7": {
        name: "(anonymous_7)",
        decl: {
          start: {
            line: 109,
            column: 2
          },
          end: {
            line: 109,
            column: 3
          }
        },
        loc: {
          start: {
            line: 109,
            column: 23
          },
          end: {
            line: 115,
            column: 3
          }
        },
        line: 109
      },
      "8": {
        name: "(anonymous_8)",
        decl: {
          start: {
            line: 117,
            column: 2
          },
          end: {
            line: 117,
            column: 3
          }
        },
        loc: {
          start: {
            line: 117,
            column: 17
          },
          end: {
            line: 119,
            column: 3
          }
        },
        line: 117
      },
      "9": {
        name: "(anonymous_9)",
        decl: {
          start: {
            line: 121,
            column: 2
          },
          end: {
            line: 121,
            column: 3
          }
        },
        loc: {
          start: {
            line: 121,
            column: 33
          },
          end: {
            line: 123,
            column: 3
          }
        },
        line: 121
      },
      "10": {
        name: "(anonymous_10)",
        decl: {
          start: {
            line: 125,
            column: 2
          },
          end: {
            line: 125,
            column: 3
          }
        },
        loc: {
          start: {
            line: 125,
            column: 22
          },
          end: {
            line: 128,
            column: 3
          }
        },
        line: 125
      },
      "11": {
        name: "(anonymous_11)",
        decl: {
          start: {
            line: 130,
            column: 2
          },
          end: {
            line: 130,
            column: 3
          }
        },
        loc: {
          start: {
            line: 130,
            column: 53
          },
          end: {
            line: 145,
            column: 3
          }
        },
        line: 130
      },
      "12": {
        name: "(anonymous_12)",
        decl: {
          start: {
            line: 147,
            column: 2
          },
          end: {
            line: 147,
            column: 3
          }
        },
        loc: {
          start: {
            line: 147,
            column: 14
          },
          end: {
            line: 152,
            column: 3
          }
        },
        line: 147
      },
      "13": {
        name: "(anonymous_13)",
        decl: {
          start: {
            line: 154,
            column: 2
          },
          end: {
            line: 154,
            column: 3
          }
        },
        loc: {
          start: {
            line: 154,
            column: 48
          },
          end: {
            line: 162,
            column: 3
          }
        },
        line: 154
      },
      "14": {
        name: "(anonymous_14)",
        decl: {
          start: {
            line: 164,
            column: 2
          },
          end: {
            line: 164,
            column: 3
          }
        },
        loc: {
          start: {
            line: 164,
            column: 83
          },
          end: {
            line: 180,
            column: 3
          }
        },
        line: 164
      },
      "15": {
        name: "(anonymous_15)",
        decl: {
          start: {
            line: 170,
            column: 11
          },
          end: {
            line: 170,
            column: 12
          }
        },
        loc: {
          start: {
            line: 171,
            column: 8
          },
          end: {
            line: 177,
            column: 10
          }
        },
        line: 171
      },
      "16": {
        name: "(anonymous_16)",
        decl: {
          start: {
            line: 179,
            column: 14
          },
          end: {
            line: 179,
            column: 15
          }
        },
        loc: {
          start: {
            line: 179,
            column: 19
          },
          end: {
            line: 179,
            column: 30
          }
        },
        line: 179
      },
      "17": {
        name: "(anonymous_17)",
        decl: {
          start: {
            line: 182,
            column: 2
          },
          end: {
            line: 182,
            column: 3
          }
        },
        loc: {
          start: {
            line: 182,
            column: 69
          },
          end: {
            line: 188,
            column: 3
          }
        },
        line: 182
      },
      "18": {
        name: "(anonymous_18)",
        decl: {
          start: {
            line: 190,
            column: 2
          },
          end: {
            line: 190,
            column: 3
          }
        },
        loc: {
          start: {
            line: 190,
            column: 16
          },
          end: {
            line: 201,
            column: 3
          }
        },
        line: 190
      },
      "19": {
        name: "(anonymous_19)",
        decl: {
          start: {
            line: 203,
            column: 2
          },
          end: {
            line: 203,
            column: 3
          }
        },
        loc: {
          start: {
            line: 216,
            column: 5
          },
          end: {
            line: 247,
            column: 3
          }
        },
        line: 216
      },
      "20": {
        name: "(anonymous_20)",
        decl: {
          start: {
            line: 249,
            column: 2
          },
          end: {
            line: 249,
            column: 3
          }
        },
        loc: {
          start: {
            line: 249,
            column: 32
          },
          end: {
            line: 264,
            column: 3
          }
        },
        line: 249
      },
      "21": {
        name: "(anonymous_21)",
        decl: {
          start: {
            line: 266,
            column: 2
          },
          end: {
            line: 266,
            column: 3
          }
        },
        loc: {
          start: {
            line: 266,
            column: 16
          },
          end: {
            line: 280,
            column: 3
          }
        },
        line: 266
      },
      "22": {
        name: "(anonymous_22)",
        decl: {
          start: {
            line: 282,
            column: 2
          },
          end: {
            line: 282,
            column: 3
          }
        },
        loc: {
          start: {
            line: 282,
            column: 37
          },
          end: {
            line: 301,
            column: 3
          }
        },
        line: 282
      },
      "23": {
        name: "(anonymous_23)",
        decl: {
          start: {
            line: 303,
            column: 2
          },
          end: {
            line: 303,
            column: 3
          }
        },
        loc: {
          start: {
            line: 303,
            column: 20
          },
          end: {
            line: 313,
            column: 3
          }
        },
        line: 303
      },
      "24": {
        name: "(anonymous_24)",
        decl: {
          start: {
            line: 315,
            column: 2
          },
          end: {
            line: 315,
            column: 3
          }
        },
        loc: {
          start: {
            line: 315,
            column: 17
          },
          end: {
            line: 331,
            column: 3
          }
        },
        line: 315
      },
      "25": {
        name: "(anonymous_25)",
        decl: {
          start: {
            line: 317,
            column: 36
          },
          end: {
            line: 317,
            column: 37
          }
        },
        loc: {
          start: {
            line: 317,
            column: 41
          },
          end: {
            line: 317,
            column: 61
          }
        },
        line: 317
      },
      "26": {
        name: "(anonymous_26)",
        decl: {
          start: {
            line: 321,
            column: 15
          },
          end: {
            line: 321,
            column: 16
          }
        },
        loc: {
          start: {
            line: 321,
            column: 32
          },
          end: {
            line: 321,
            column: 71
          }
        },
        line: 321
      },
      "27": {
        name: "(anonymous_27)",
        decl: {
          start: {
            line: 333,
            column: 2
          },
          end: {
            line: 333,
            column: 3
          }
        },
        loc: {
          start: {
            line: 333,
            column: 11
          },
          end: {
            line: 363,
            column: 3
          }
        },
        line: 333
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 29,
            column: 18
          },
          end: {
            line: 33,
            column: 15
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 30,
            column: 6
          },
          end: {
            line: 32,
            column: 7
          }
        }, {
          start: {
            line: 33,
            column: 6
          },
          end: {
            line: 33,
            column: 15
          }
        }],
        line: 29
      },
      "1": {
        loc: {
          start: {
            line: 34,
            column: 18
          },
          end: {
            line: 38,
            column: 15
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 35,
            column: 6
          },
          end: {
            line: 37,
            column: 7
          }
        }, {
          start: {
            line: 38,
            column: 6
          },
          end: {
            line: 38,
            column: 15
          }
        }],
        line: 34
      },
      "2": {
        loc: {
          start: {
            line: 43,
            column: 49
          },
          end: {
            line: 43,
            column: 68
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 43,
            column: 49
          },
          end: {
            line: 43,
            column: 53
          }
        }, {
          start: {
            line: 43,
            column: 57
          },
          end: {
            line: 43,
            column: 68
          }
        }],
        line: 43
      },
      "3": {
        loc: {
          start: {
            line: 43,
            column: 70
          },
          end: {
            line: 43,
            column: 99
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 43,
            column: 70
          },
          end: {
            line: 43,
            column: 80
          }
        }, {
          start: {
            line: 43,
            column: 84
          },
          end: {
            line: 43,
            column: 99
          }
        }],
        line: 43
      },
      "4": {
        loc: {
          start: {
            line: 49,
            column: 7
          },
          end: {
            line: 53,
            column: 7
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 49,
            column: 7
          },
          end: {
            line: 49,
            column: 19
          }
        }, {
          start: {
            line: 49,
            column: 23
          },
          end: {
            line: 49,
            column: 34
          }
        }, {
          start: {
            line: 50,
            column: 8
          },
          end: {
            line: 52,
            column: 15
          }
        }],
        line: 49
      },
      "5": {
        loc: {
          start: {
            line: 94,
            column: 4
          },
          end: {
            line: 96,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 94,
            column: 4
          },
          end: {
            line: 96,
            column: 5
          }
        }, {
          start: {
            line: 94,
            column: 4
          },
          end: {
            line: 96,
            column: 5
          }
        }],
        line: 94
      },
      "6": {
        loc: {
          start: {
            line: 94,
            column: 8
          },
          end: {
            line: 94,
            column: 47
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 94,
            column: 8
          },
          end: {
            line: 94,
            column: 18
          }
        }, {
          start: {
            line: 94,
            column: 22
          },
          end: {
            line: 94,
            column: 47
          }
        }],
        line: 94
      },
      "7": {
        loc: {
          start: {
            line: 106,
            column: 4
          },
          end: {
            line: 106,
            column: 62
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 106,
            column: 4
          },
          end: {
            line: 106,
            column: 62
          }
        }, {
          start: {
            line: 106,
            column: 4
          },
          end: {
            line: 106,
            column: 62
          }
        }],
        line: 106
      },
      "8": {
        loc: {
          start: {
            line: 111,
            column: 4
          },
          end: {
            line: 113,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 111,
            column: 4
          },
          end: {
            line: 113,
            column: 5
          }
        }, {
          start: {
            line: 111,
            column: 4
          },
          end: {
            line: 113,
            column: 5
          }
        }],
        line: 111
      },
      "9": {
        loc: {
          start: {
            line: 127,
            column: 11
          },
          end: {
            line: 127,
            column: 79
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 127,
            column: 11
          },
          end: {
            line: 127,
            column: 26
          }
        }, {
          start: {
            line: 127,
            column: 30
          },
          end: {
            line: 127,
            column: 55
          }
        }, {
          start: {
            line: 127,
            column: 59
          },
          end: {
            line: 127,
            column: 79
          }
        }],
        line: 127
      },
      "10": {
        loc: {
          start: {
            line: 131,
            column: 24
          },
          end: {
            line: 131,
            column: 34
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 131,
            column: 32
          },
          end: {
            line: 131,
            column: 34
          }
        }],
        line: 131
      },
      "11": {
        loc: {
          start: {
            line: 132,
            column: 4
          },
          end: {
            line: 144,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 132,
            column: 4
          },
          end: {
            line: 144,
            column: 5
          }
        }, {
          start: {
            line: 132,
            column: 4
          },
          end: {
            line: 144,
            column: 5
          }
        }],
        line: 132
      },
      "12": {
        loc: {
          start: {
            line: 133,
            column: 6
          },
          end: {
            line: 133,
            column: 42
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 133,
            column: 6
          },
          end: {
            line: 133,
            column: 42
          }
        }, {
          start: {
            line: 133,
            column: 6
          },
          end: {
            line: 133,
            column: 42
          }
        }],
        line: 133
      },
      "13": {
        loc: {
          start: {
            line: 134,
            column: 6
          },
          end: {
            line: 143,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 134,
            column: 6
          },
          end: {
            line: 143,
            column: 7
          }
        }, {
          start: {
            line: 134,
            column: 6
          },
          end: {
            line: 143,
            column: 7
          }
        }],
        line: 134
      },
      "14": {
        loc: {
          start: {
            line: 134,
            column: 11
          },
          end: {
            line: 134,
            column: 31
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 134,
            column: 11
          },
          end: {
            line: 134,
            column: 25
          }
        }, {
          start: {
            line: 134,
            column: 29
          },
          end: {
            line: 134,
            column: 31
          }
        }],
        line: 134
      },
      "15": {
        loc: {
          start: {
            line: 134,
            column: 47
          },
          end: {
            line: 134,
            column: 58
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 134,
            column: 47
          },
          end: {
            line: 134,
            column: 52
          }
        }, {
          start: {
            line: 134,
            column: 56
          },
          end: {
            line: 134,
            column: 58
          }
        }],
        line: 134
      },
      "16": {
        loc: {
          start: {
            line: 136,
            column: 13
          },
          end: {
            line: 143,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 136,
            column: 13
          },
          end: {
            line: 143,
            column: 7
          }
        }, {
          start: {
            line: 136,
            column: 13
          },
          end: {
            line: 143,
            column: 7
          }
        }],
        line: 136
      },
      "17": {
        loc: {
          start: {
            line: 136,
            column: 18
          },
          end: {
            line: 136,
            column: 37
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 136,
            column: 18
          },
          end: {
            line: 136,
            column: 31
          }
        }, {
          start: {
            line: 136,
            column: 35
          },
          end: {
            line: 136,
            column: 37
          }
        }],
        line: 136
      },
      "18": {
        loc: {
          start: {
            line: 136,
            column: 51
          },
          end: {
            line: 136,
            column: 61
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 136,
            column: 51
          },
          end: {
            line: 136,
            column: 55
          }
        }, {
          start: {
            line: 136,
            column: 59
          },
          end: {
            line: 136,
            column: 61
          }
        }],
        line: 136
      },
      "19": {
        loc: {
          start: {
            line: 138,
            column: 13
          },
          end: {
            line: 143,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 138,
            column: 13
          },
          end: {
            line: 143,
            column: 7
          }
        }, {
          start: {
            line: 138,
            column: 13
          },
          end: {
            line: 143,
            column: 7
          }
        }],
        line: 138
      },
      "20": {
        loc: {
          start: {
            line: 138,
            column: 17
          },
          end: {
            line: 138,
            column: 53
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 138,
            column: 17
          },
          end: {
            line: 138,
            column: 29
          }
        }, {
          start: {
            line: 138,
            column: 33
          },
          end: {
            line: 138,
            column: 53
          }
        }],
        line: 138
      },
      "21": {
        loc: {
          start: {
            line: 148,
            column: 4
          },
          end: {
            line: 148,
            column: 38
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 148,
            column: 4
          },
          end: {
            line: 148,
            column: 38
          }
        }, {
          start: {
            line: 148,
            column: 4
          },
          end: {
            line: 148,
            column: 38
          }
        }],
        line: 148
      },
      "22": {
        loc: {
          start: {
            line: 154,
            column: 34
          },
          end: {
            line: 154,
            column: 46
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 154,
            column: 41
          },
          end: {
            line: 154,
            column: 46
          }
        }],
        line: 154
      },
      "23": {
        loc: {
          start: {
            line: 156,
            column: 21
          },
          end: {
            line: 156,
            column: 55
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 156,
            column: 21
          },
          end: {
            line: 156,
            column: 49
          }
        }, {
          start: {
            line: 156,
            column: 53
          },
          end: {
            line: 156,
            column: 55
          }
        }],
        line: 156
      },
      "24": {
        loc: {
          start: {
            line: 157,
            column: 4
          },
          end: {
            line: 157,
            column: 21
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 157,
            column: 4
          },
          end: {
            line: 157,
            column: 21
          }
        }, {
          start: {
            line: 157,
            column: 4
          },
          end: {
            line: 157,
            column: 21
          }
        }],
        line: 157
      },
      "25": {
        loc: {
          start: {
            line: 159,
            column: 4
          },
          end: {
            line: 161,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 159,
            column: 4
          },
          end: {
            line: 161,
            column: 5
          }
        }, {
          start: {
            line: 159,
            column: 4
          },
          end: {
            line: 161,
            column: 5
          }
        }],
        line: 159
      },
      "26": {
        loc: {
          start: {
            line: 167,
            column: 51
          },
          end: {
            line: 167,
            column: 104
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 167,
            column: 51
          },
          end: {
            line: 167,
            column: 63
          }
        }, {
          start: {
            line: 167,
            column: 67
          },
          end: {
            line: 167,
            column: 104
          }
        }],
        line: 167
      },
      "27": {
        loc: {
          start: {
            line: 183,
            column: 4
          },
          end: {
            line: 185,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 183,
            column: 4
          },
          end: {
            line: 185,
            column: 5
          }
        }, {
          start: {
            line: 183,
            column: 4
          },
          end: {
            line: 185,
            column: 5
          }
        }],
        line: 183
      },
      "28": {
        loc: {
          start: {
            line: 191,
            column: 23
          },
          end: {
            line: 191,
            column: 33
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 191,
            column: 31
          },
          end: {
            line: 191,
            column: 33
          }
        }],
        line: 191
      },
      "29": {
        loc: {
          start: {
            line: 194,
            column: 4
          },
          end: {
            line: 198,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 194,
            column: 4
          },
          end: {
            line: 198,
            column: 5
          }
        }, {
          start: {
            line: 194,
            column: 4
          },
          end: {
            line: 198,
            column: 5
          }
        }],
        line: 194
      },
      "30": {
        loc: {
          start: {
            line: 194,
            column: 8
          },
          end: {
            line: 194,
            column: 37
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 194,
            column: 8
          },
          end: {
            line: 194,
            column: 17
          }
        }, {
          start: {
            line: 194,
            column: 21
          },
          end: {
            line: 194,
            column: 37
          }
        }],
        line: 194
      },
      "31": {
        loc: {
          start: {
            line: 219,
            column: 4
          },
          end: {
            line: 227,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 219,
            column: 4
          },
          end: {
            line: 227,
            column: 5
          }
        }, {
          start: {
            line: 219,
            column: 4
          },
          end: {
            line: 227,
            column: 5
          }
        }],
        line: 219
      },
      "32": {
        loc: {
          start: {
            line: 220,
            column: 6
          },
          end: {
            line: 224,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 220,
            column: 6
          },
          end: {
            line: 224,
            column: 7
          }
        }, {
          start: {
            line: 220,
            column: 6
          },
          end: {
            line: 224,
            column: 7
          }
        }],
        line: 220
      },
      "33": {
        loc: {
          start: {
            line: 223,
            column: 14
          },
          end: {
            line: 223,
            column: 64
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 223,
            column: 47
          },
          end: {
            line: 223,
            column: 57
          }
        }, {
          start: {
            line: 223,
            column: 60
          },
          end: {
            line: 223,
            column: 64
          }
        }],
        line: 223
      },
      "34": {
        loc: {
          start: {
            line: 226,
            column: 12
          },
          end: {
            line: 226,
            column: 37
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 226,
            column: 12
          },
          end: {
            line: 226,
            column: 16
          }
        }, {
          start: {
            line: 226,
            column: 20
          },
          end: {
            line: 226,
            column: 37
          }
        }],
        line: 226
      },
      "35": {
        loc: {
          start: {
            line: 229,
            column: 4
          },
          end: {
            line: 229,
            column: 25
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 229,
            column: 4
          },
          end: {
            line: 229,
            column: 25
          }
        }, {
          start: {
            line: 229,
            column: 4
          },
          end: {
            line: 229,
            column: 25
          }
        }],
        line: 229
      },
      "36": {
        loc: {
          start: {
            line: 275,
            column: 22
          },
          end: {
            line: 275,
            column: 35
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 275,
            column: 30
          },
          end: {
            line: 275,
            column: 31
          }
        }, {
          start: {
            line: 275,
            column: 34
          },
          end: {
            line: 275,
            column: 35
          }
        }],
        line: 275
      },
      "37": {
        loc: {
          start: {
            line: 284,
            column: 4
          },
          end: {
            line: 286,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 284,
            column: 4
          },
          end: {
            line: 286,
            column: 5
          }
        }, {
          start: {
            line: 284,
            column: 4
          },
          end: {
            line: 286,
            column: 5
          }
        }],
        line: 284
      },
      "38": {
        loc: {
          start: {
            line: 284,
            column: 8
          },
          end: {
            line: 284,
            column: 25
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 284,
            column: 8
          },
          end: {
            line: 284,
            column: 13
          }
        }, {
          start: {
            line: 284,
            column: 17
          },
          end: {
            line: 284,
            column: 25
          }
        }],
        line: 284
      },
      "39": {
        loc: {
          start: {
            line: 290,
            column: 15
          },
          end: {
            line: 290,
            column: 55
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 290,
            column: 24
          },
          end: {
            line: 290,
            column: 43
          }
        }, {
          start: {
            line: 290,
            column: 46
          },
          end: {
            line: 290,
            column: 55
          }
        }],
        line: 290
      },
      "40": {
        loc: {
          start: {
            line: 294,
            column: 10
          },
          end: {
            line: 294,
            column: 50
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 294,
            column: 10
          },
          end: {
            line: 294,
            column: 20
          }
        }, {
          start: {
            line: 294,
            column: 24
          },
          end: {
            line: 294,
            column: 50
          }
        }],
        line: 294
      },
      "41": {
        loc: {
          start: {
            line: 305,
            column: 4
          },
          end: {
            line: 305,
            column: 60
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 305,
            column: 4
          },
          end: {
            line: 305,
            column: 60
          }
        }, {
          start: {
            line: 305,
            column: 4
          },
          end: {
            line: 305,
            column: 60
          }
        }],
        line: 305
      },
      "42": {
        loc: {
          start: {
            line: 305,
            column: 8
          },
          end: {
            line: 305,
            column: 47
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 305,
            column: 8
          },
          end: {
            line: 305,
            column: 18
          }
        }, {
          start: {
            line: 305,
            column: 23
          },
          end: {
            line: 305,
            column: 31
          }
        }, {
          start: {
            line: 305,
            column: 35
          },
          end: {
            line: 305,
            column: 46
          }
        }],
        line: 305
      },
      "43": {
        loc: {
          start: {
            line: 309,
            column: 75
          },
          end: {
            line: 309,
            column: 103
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 309,
            column: 86
          },
          end: {
            line: 309,
            column: 93
          }
        }, {
          start: {
            line: 309,
            column: 96
          },
          end: {
            line: 309,
            column: 103
          }
        }],
        line: 309
      },
      "44": {
        loc: {
          start: {
            line: 310,
            column: 9
          },
          end: {
            line: 310,
            column: 31
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 310,
            column: 9
          },
          end: {
            line: 310,
            column: 18
          }
        }, {
          start: {
            line: 310,
            column: 22
          },
          end: {
            line: 310,
            column: 31
          }
        }],
        line: 310
      },
      "45": {
        loc: {
          start: {
            line: 316,
            column: 19
          },
          end: {
            line: 316,
            column: 29
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 316,
            column: 27
          },
          end: {
            line: 316,
            column: 29
          }
        }],
        line: 316
      },
      "46": {
        loc: {
          start: {
            line: 317,
            column: 19
          },
          end: {
            line: 317,
            column: 30
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 317,
            column: 19
          },
          end: {
            line: 317,
            column: 24
          }
        }, {
          start: {
            line: 317,
            column: 28
          },
          end: {
            line: 317,
            column: 30
          }
        }],
        line: 317
      },
      "47": {
        loc: {
          start: {
            line: 318,
            column: 17
          },
          end: {
            line: 318,
            column: 43
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 318,
            column: 17
          },
          end: {
            line: 318,
            column: 29
          }
        }, {
          start: {
            line: 318,
            column: 33
          },
          end: {
            line: 318,
            column: 43
          }
        }],
        line: 318
      },
      "48": {
        loc: {
          start: {
            line: 319,
            column: 4
          },
          end: {
            line: 322,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 319,
            column: 4
          },
          end: {
            line: 322,
            column: 5
          }
        }, {
          start: {
            line: 319,
            column: 4
          },
          end: {
            line: 322,
            column: 5
          }
        }],
        line: 319
      },
      "49": {
        loc: {
          start: {
            line: 325,
            column: 4
          },
          end: {
            line: 327,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 325,
            column: 4
          },
          end: {
            line: 327,
            column: 5
          }
        }, {
          start: {
            line: 325,
            column: 4
          },
          end: {
            line: 327,
            column: 5
          }
        }],
        line: 325
      },
      "50": {
        loc: {
          start: {
            line: 325,
            column: 8
          },
          end: {
            line: 325,
            column: 34
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 325,
            column: 8
          },
          end: {
            line: 325,
            column: 18
          }
        }, {
          start: {
            line: 325,
            column: 22
          },
          end: {
            line: 325,
            column: 34
          }
        }],
        line: 325
      },
      "51": {
        loc: {
          start: {
            line: 334,
            column: 19
          },
          end: {
            line: 334,
            column: 29
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 334,
            column: 27
          },
          end: {
            line: 334,
            column: 29
          }
        }],
        line: 334
      },
      "52": {
        loc: {
          start: {
            line: 338,
            column: 29
          },
          end: {
            line: 338,
            column: 51
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 338,
            column: 29
          },
          end: {
            line: 338,
            column: 37
          }
        }, {
          start: {
            line: 338,
            column: 41
          },
          end: {
            line: 338,
            column: 51
          }
        }],
        line: 338
      },
      "53": {
        loc: {
          start: {
            line: 344,
            column: 10
          },
          end: {
            line: 344,
            column: 58
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 344,
            column: 10
          },
          end: {
            line: 344,
            column: 26
          }
        }, {
          start: {
            line: 344,
            column: 30
          },
          end: {
            line: 344,
            column: 58
          }
        }],
        line: 344
      },
      "54": {
        loc: {
          start: {
            line: 347,
            column: 14
          },
          end: {
            line: 347,
            column: 43
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 347,
            column: 14
          },
          end: {
            line: 347,
            column: 20
          }
        }, {
          start: {
            line: 347,
            column: 25
          },
          end: {
            line: 347,
            column: 33
          }
        }, {
          start: {
            line: 347,
            column: 37
          },
          end: {
            line: 347,
            column: 42
          }
        }],
        line: 347
      },
      "55": {
        loc: {
          start: {
            line: 352,
            column: 55
          },
          end: {
            line: 352,
            column: 87
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 352,
            column: 55
          },
          end: {
            line: 352,
            column: 71
          }
        }, {
          start: {
            line: 352,
            column: 75
          },
          end: {
            line: 352,
            column: 87
          }
        }],
        line: 352
      },
      "56": {
        loc: {
          start: {
            line: 352,
            column: 89
          },
          end: {
            line: 352,
            column: 118
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 352,
            column: 89
          },
          end: {
            line: 352,
            column: 96
          }
        }, {
          start: {
            line: 352,
            column: 100
          },
          end: {
            line: 352,
            column: 118
          }
        }],
        line: 352
      },
      "57": {
        loc: {
          start: {
            line: 353,
            column: 12
          },
          end: {
            line: 353,
            column: 56
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 353,
            column: 12
          },
          end: {
            line: 353,
            column: 22
          }
        }, {
          start: {
            line: 353,
            column: 26
          },
          end: {
            line: 353,
            column: 56
          }
        }],
        line: 353
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0,
      "25": 0,
      "26": 0,
      "27": 0,
      "28": 0,
      "29": 0,
      "30": 0,
      "31": 0,
      "32": 0,
      "33": 0,
      "34": 0,
      "35": 0,
      "36": 0,
      "37": 0,
      "38": 0,
      "39": 0,
      "40": 0,
      "41": 0,
      "42": 0,
      "43": 0,
      "44": 0,
      "45": 0,
      "46": 0,
      "47": 0,
      "48": 0,
      "49": 0,
      "50": 0,
      "51": 0,
      "52": 0,
      "53": 0,
      "54": 0,
      "55": 0,
      "56": 0,
      "57": 0,
      "58": 0,
      "59": 0,
      "60": 0,
      "61": 0,
      "62": 0,
      "63": 0,
      "64": 0,
      "65": 0,
      "66": 0,
      "67": 0,
      "68": 0,
      "69": 0,
      "70": 0,
      "71": 0,
      "72": 0,
      "73": 0,
      "74": 0,
      "75": 0,
      "76": 0,
      "77": 0,
      "78": 0,
      "79": 0,
      "80": 0,
      "81": 0,
      "82": 0,
      "83": 0,
      "84": 0,
      "85": 0,
      "86": 0,
      "87": 0,
      "88": 0,
      "89": 0,
      "90": 0,
      "91": 0,
      "92": 0,
      "93": 0,
      "94": 0,
      "95": 0,
      "96": 0,
      "97": 0,
      "98": 0,
      "99": 0,
      "100": 0,
      "101": 0,
      "102": 0,
      "103": 0,
      "104": 0,
      "105": 0,
      "106": 0,
      "107": 0,
      "108": 0,
      "109": 0,
      "110": 0,
      "111": 0,
      "112": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0,
      "25": 0,
      "26": 0,
      "27": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0],
      "2": [0, 0],
      "3": [0, 0],
      "4": [0, 0, 0],
      "5": [0, 0],
      "6": [0, 0],
      "7": [0, 0],
      "8": [0, 0],
      "9": [0, 0, 0],
      "10": [0],
      "11": [0, 0],
      "12": [0, 0],
      "13": [0, 0],
      "14": [0, 0],
      "15": [0, 0],
      "16": [0, 0],
      "17": [0, 0],
      "18": [0, 0],
      "19": [0, 0],
      "20": [0, 0],
      "21": [0, 0],
      "22": [0],
      "23": [0, 0],
      "24": [0, 0],
      "25": [0, 0],
      "26": [0, 0],
      "27": [0, 0],
      "28": [0],
      "29": [0, 0],
      "30": [0, 0],
      "31": [0, 0],
      "32": [0, 0],
      "33": [0, 0],
      "34": [0, 0],
      "35": [0, 0],
      "36": [0, 0],
      "37": [0, 0],
      "38": [0, 0],
      "39": [0, 0],
      "40": [0, 0],
      "41": [0, 0],
      "42": [0, 0, 0],
      "43": [0, 0],
      "44": [0, 0],
      "45": [0],
      "46": [0, 0],
      "47": [0, 0],
      "48": [0, 0],
      "49": [0, 0],
      "50": [0, 0],
      "51": [0],
      "52": [0, 0],
      "53": [0, 0],
      "54": [0, 0, 0],
      "55": [0, 0],
      "56": [0, 0],
      "57": [0, 0]
    },
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184"
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

import _objectWithoutProperties from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import _classCallCheck from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
var _jsxFileName = "/Users/spana/SHEIN/shineout/src/Cascader/Result.tsx";

function _createSuper2(Derived) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

import React, { PureComponent } from 'react';
import classnames from 'classnames';
import { inputClass } from '../Input/styles';
import { selectClass } from '../Select/styles';
import { cascaderClass } from './styles';
import Input from './Input';
import icons from '../icons';
import More, { getResetMore } from '../Select/More';
import { addResizeObserver } from '../utils/dom/element';
import { isEmpty, isNumber } from '../utils/is';
import { CHANGE_TOPIC } from '../Datum/types';
import Caret from '../icons/Caret';
import { getDirectionClass } from '../utils/classname';
import InputTitle from '../InputTitle';
import { inputTitleClass } from '../InputTitle/styles';

function Item(_ref) {
  var children = _ref.children,
      close = _ref.close,
      className = _ref.className,
      data = _ref.data,
      isPopover = _ref.isPopover,
      singleRemove = _ref.singleRemove,
      click = _ref.click,
      only = _ref.only,
      isDisabled = _ref.isDisabled;
  cov_8fog4h7k9.f[0]++;
  var onClose = (cov_8fog4h7k9.s[0]++, close ? (cov_8fog4h7k9.b[0][0]++, function (e) {
    cov_8fog4h7k9.f[1]++;
    cov_8fog4h7k9.s[1]++;
    close(data, isPopover, e);
  }) : (cov_8fog4h7k9.b[0][1]++, undefined));
  var onClick = (cov_8fog4h7k9.s[2]++, click ? (cov_8fog4h7k9.b[1][0]++, function () {
    cov_8fog4h7k9.f[2]++;
    cov_8fog4h7k9.s[3]++;
    click(data, isPopover);
  }) : (cov_8fog4h7k9.b[1][1]++, undefined));
  cov_8fog4h7k9.s[4]++;
  return (
    /*#__PURE__*/
    React.createElement("a", {
      tabIndex: -1,
      className: classnames(cascaderClass(getDirectionClass('item'), (cov_8fog4h7k9.b[2][0]++, only) && (cov_8fog4h7k9.b[2][1]++, 'item-only'), (cov_8fog4h7k9.b[3][0]++, isDisabled) && (cov_8fog4h7k9.b[3][1]++, 'item-disabled')), className),
      onClick: onClick,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 40,
        columnNumber: 5
      }
    }, children, (cov_8fog4h7k9.b[4][0]++, singleRemove) && (cov_8fog4h7k9.b[4][1]++, !isDisabled) && (cov_8fog4h7k9.b[4][2]++,
    /*#__PURE__*/
    React.createElement("span", {
      className: cascaderClass(getDirectionClass('single-remove')),
      onClick: onClose,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 50,
        columnNumber: 9
      }
    }, icons.Close)))
  );
}

var Result =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(Result, _PureComponent);

  var _super = _createSuper2(Result);

  function Result(props) {
    var _this;

    _classCallCheck(this, Result);

    cov_8fog4h7k9.f[3]++;
    cov_8fog4h7k9.s[5]++;
    _this = _super.call(this, props);
    _this.cancelResizeObserver = void 0;
    _this.resultEl = void 0;
    _this.shouldResetMore = void 0;
    cov_8fog4h7k9.s[6]++;
    _this.state = {
      more: -1
    };
    cov_8fog4h7k9.s[7]++;
    _this.handleNodeClick = _this.handleNodeClick.bind(_assertThisInitialized(_this));
    cov_8fog4h7k9.s[8]++;
    _this.renderItem = _this.renderItem.bind(_assertThisInitialized(_this));
    cov_8fog4h7k9.s[9]++;
    _this.removeTargetNode = _this.removeTargetNode.bind(_assertThisInitialized(_this));
    cov_8fog4h7k9.s[10]++;
    _this.handleUpdate = _this.handleUpdate.bind(_assertThisInitialized(_this));
    cov_8fog4h7k9.s[11]++;
    _this.bindResult = _this.bindResult.bind(_assertThisInitialized(_this));
    cov_8fog4h7k9.s[12]++;
    _this.resetMore = _this.resetMore.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(Result, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      cov_8fog4h7k9.f[4]++;

      var _ref2 = (cov_8fog4h7k9.s[13]++, this.props),
          datum = _ref2.datum;

      cov_8fog4h7k9.s[14]++;
      datum.subscribe(CHANGE_TOPIC, this.handleUpdate);

      var _ref3 = (cov_8fog4h7k9.s[15]++, this.props),
          compressed = _ref3.compressed;

      cov_8fog4h7k9.s[16]++;

      if ((cov_8fog4h7k9.b[6][0]++, compressed) && (cov_8fog4h7k9.b[6][1]++, !this.isCompressedBound())) {
        cov_8fog4h7k9.b[5][0]++;
        cov_8fog4h7k9.s[17]++;
        this.cancelResizeObserver = addResizeObserver(this.resultEl, this.resetMore, {
          direction: 'x'
        });
      } else {
        cov_8fog4h7k9.b[5][1]++;
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(preProps) {
      cov_8fog4h7k9.f[5]++;
      cov_8fog4h7k9.s[18]++;
      this.updateMore(preProps);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      cov_8fog4h7k9.f[6]++;

      var _ref4 = (cov_8fog4h7k9.s[19]++, this.props),
          datum = _ref4.datum;

      cov_8fog4h7k9.s[20]++;
      datum.unsubscribe(CHANGE_TOPIC, this.handleUpdate);
      cov_8fog4h7k9.s[21]++;

      if (this.cancelResizeObserver) {
        cov_8fog4h7k9.b[7][0]++;
        cov_8fog4h7k9.s[22]++;
        this.cancelResizeObserver();
      } else {
        cov_8fog4h7k9.b[7][1]++;
      }
    }
  }, {
    key: "getCompressedBound",
    value: function getCompressedBound() {
      cov_8fog4h7k9.f[7]++;

      var _ref5 = (cov_8fog4h7k9.s[23]++, this.props),
          compressedBound = _ref5.compressedBound;

      cov_8fog4h7k9.s[24]++;

      if (this.isCompressedBound()) {
        cov_8fog4h7k9.b[8][0]++;
        cov_8fog4h7k9.s[25]++;
        return compressedBound;
      } else {
        cov_8fog4h7k9.b[8][1]++;
      }

      cov_8fog4h7k9.s[26]++;
      return this.state.more;
    }
  }, {
    key: "handleUpdate",
    value: function handleUpdate() {
      cov_8fog4h7k9.f[8]++;
      cov_8fog4h7k9.s[27]++;
      this.forceUpdate();
    }
  }, {
    key: "bindResult",
    value: function bindResult(el) {
      cov_8fog4h7k9.f[9]++;
      cov_8fog4h7k9.s[28]++;
      this.resultEl = el;
    }
  }, {
    key: "isCompressedBound",
    value: function isCompressedBound() {
      cov_8fog4h7k9.f[10]++;

      var _ref6 = (cov_8fog4h7k9.s[29]++, this.props),
          compressedBound = _ref6.compressedBound;

      cov_8fog4h7k9.s[30]++;
      return (cov_8fog4h7k9.b[9][0]++, compressedBound) && (cov_8fog4h7k9.b[9][1]++, isNumber(compressedBound)) && (cov_8fog4h7k9.b[9][2]++, compressedBound >= 1);
    }
  }, {
    key: "updateMore",
    value: function updateMore(preProps) {
      cov_8fog4h7k9.f[11]++;

      var _ref7 = (cov_8fog4h7k9.s[31]++, this.props),
          compressed = _ref7.compressed,
          _ref7$value = _ref7.value,
          value = _ref7$value === void 0 ? (cov_8fog4h7k9.b[10][0]++, []) : _ref7$value,
          onFilter = _ref7.onFilter,
          data = _ref7.data;

      cov_8fog4h7k9.s[32]++;

      if (compressed) {
        cov_8fog4h7k9.b[11][0]++;
        cov_8fog4h7k9.s[33]++;

        if (this.isCompressedBound()) {
          cov_8fog4h7k9.b[12][0]++;
          cov_8fog4h7k9.s[34]++;
          return;
        } else {
          cov_8fog4h7k9.b[12][1]++;
        }

        cov_8fog4h7k9.s[35]++;

        if (((cov_8fog4h7k9.b[14][0]++, preProps.value) || (cov_8fog4h7k9.b[14][1]++, [])).join('') !== ((cov_8fog4h7k9.b[15][0]++, value) || (cov_8fog4h7k9.b[15][1]++, [])).join('')) {
          cov_8fog4h7k9.b[13][0]++;
          cov_8fog4h7k9.s[36]++;
          this.resetMore();
        } else {
          cov_8fog4h7k9.b[13][1]++;
          cov_8fog4h7k9.s[37]++;

          if (((cov_8fog4h7k9.b[17][0]++, preProps.data) || (cov_8fog4h7k9.b[17][1]++, [])).length !== ((cov_8fog4h7k9.b[18][0]++, data) || (cov_8fog4h7k9.b[18][1]++, [])).length) {
            cov_8fog4h7k9.b[16][0]++;
            cov_8fog4h7k9.s[38]++;
            this.resetMore();
          } else {
            cov_8fog4h7k9.b[16][1]++;
            cov_8fog4h7k9.s[39]++;

            if ((cov_8fog4h7k9.b[20][0]++, value.length) && (cov_8fog4h7k9.b[20][1]++, this.shouldResetMore)) {
              cov_8fog4h7k9.b[19][0]++;
              cov_8fog4h7k9.s[40]++;
              this.shouldResetMore = false;

              var _more = (cov_8fog4h7k9.s[41]++, getResetMore(onFilter, this.resultEl, this.resultEl.querySelectorAll(".".concat(cascaderClass('item')))));

              cov_8fog4h7k9.s[42]++;
              this.setState({
                more: _more
              });
              cov_8fog4h7k9.s[43]++;
              this.forceUpdate();
            } else {
              cov_8fog4h7k9.b[19][1]++;
            }
          }
        }
      } else {
        cov_8fog4h7k9.b[11][1]++;
      }
    }
  }, {
    key: "resetMore",
    value: function resetMore() {
      cov_8fog4h7k9.f[12]++;
      cov_8fog4h7k9.s[44]++;

      if (!this.props.compressed) {
        cov_8fog4h7k9.b[21][0]++;
        cov_8fog4h7k9.s[45]++;
        return;
      } else {
        cov_8fog4h7k9.b[21][1]++;
      }

      cov_8fog4h7k9.s[46]++;
      this.shouldResetMore = true;
      cov_8fog4h7k9.s[47]++;
      this.setState({
        more: -1
      });
      cov_8fog4h7k9.s[48]++;
      this.forceUpdate();
    }
  }, {
    key: "handleNodeClick",
    value: function handleNodeClick(data) {
      var show = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (cov_8fog4h7k9.b[22][0]++, false);
      cov_8fog4h7k9.f[13]++;
      var id = (cov_8fog4h7k9.s[49]++, this.props.datum.getKey(data));

      var _ref8 = (cov_8fog4h7k9.s[50]++, (cov_8fog4h7k9.b[23][0]++, this.props.datum.getPath(id)) || (cov_8fog4h7k9.b[23][1]++, {})),
          path = _ref8.path;

      cov_8fog4h7k9.s[51]++;

      if (!path) {
        cov_8fog4h7k9.b[24][0]++;
        cov_8fog4h7k9.s[52]++;
        return;
      } else {
        cov_8fog4h7k9.b[24][1]++;
      }

      cov_8fog4h7k9.s[53]++;
      this.props.onPathChange(id, null, path);
      cov_8fog4h7k9.s[54]++;

      if (show) {
        cov_8fog4h7k9.b[25][0]++;
        cov_8fog4h7k9.s[55]++;
        this.props.showList();
      } else {
        cov_8fog4h7k9.b[25][1]++;
      }
    }
  }, {
    key: "handleNode",
    value: function handleNode(nodes, render) {
      var _this2 = this;

      cov_8fog4h7k9.f[14]++;

      var _ref9 = (cov_8fog4h7k9.s[56]++, this.props),
          singleRemove = _ref9.singleRemove;

      var removeContainerClassName = (cov_8fog4h7k9.s[57]++, cascaderClass((cov_8fog4h7k9.b[26][0]++, singleRemove) && (cov_8fog4h7k9.b[26][1]++, getDirectionClass('remove-container'))));
      cov_8fog4h7k9.s[58]++;
      return nodes.map(function (n, i) {
        cov_8fog4h7k9.f[15]++;
        cov_8fog4h7k9.s[59]++;
        return _this2.renderItem({
          className: removeContainerClassName,
          index: i,
          data: n,
          raw: nodes,
          render: render
        });
      }).filter(function (n) {
        cov_8fog4h7k9.f[16]++;
        cov_8fog4h7k9.s[60]++;
        return !isEmpty(n);
      });
    }
  }, {
    key: "removeTargetNode",
    value: function removeTargetNode(node, isPopover, event) {
      cov_8fog4h7k9.f[17]++;
      cov_8fog4h7k9.s[61]++;

      if (isPopover) {
        cov_8fog4h7k9.b[27][0]++;
        cov_8fog4h7k9.s[62]++;
        event.stopPropagation();
      } else {
        cov_8fog4h7k9.b[27][1]++;
      }

      var _ref10 = (cov_8fog4h7k9.s[63]++, this.props),
          handleRemove = _ref10.handleRemove;

      cov_8fog4h7k9.s[64]++;
      handleRemove(node);
    }
  }, {
    key: "renderClear",
    value: function renderClear() {
      cov_8fog4h7k9.f[18]++;

      var _ref11 = (cov_8fog4h7k9.s[65]++, this.props),
          clearable = _ref11.clearable,
          _ref11$value = _ref11.value,
          value = _ref11$value === void 0 ? (cov_8fog4h7k9.b[28][0]++, []) : _ref11$value,
          onClear = _ref11.onClear;

      var className = (cov_8fog4h7k9.s[66]++, classnames(selectClass('indicator', 'close'), cascaderClass(getDirectionClass('close'))));
      cov_8fog4h7k9.s[67]++;

      if ((cov_8fog4h7k9.b[30][0]++, clearable) && (cov_8fog4h7k9.b[30][1]++, value.length > 0)) {
        cov_8fog4h7k9.b[29][0]++;
        cov_8fog4h7k9.s[68]++;

        /* eslint-disable */
        return (
          /*#__PURE__*/
          React.createElement("a", {
            tabIndex: -1,
            className: className,
            onClick: onClear,
            __self: this,
            __source: {
              fileName: _jsxFileName,
              lineNumber: 196,
              columnNumber: 14
            }
          })
        );
        /* eslint-enable */
      } else {
        cov_8fog4h7k9.b[29][1]++;
      }

      cov_8fog4h7k9.s[69]++;
      return null;
    }
  }, {
    key: "renderItem",
    value: function renderItem(_ref12) {
      var index = _ref12.index,
          render = _ref12.render,
          data = _ref12.data,
          raw = _ref12.raw,
          className = _ref12.className,
          options = _objectWithoutProperties(_ref12, ["index", "render", "data", "raw", "className"]);

      cov_8fog4h7k9.f[19]++;

      var _ref13 = (cov_8fog4h7k9.s[70]++, this.props),
          singleRemove = _ref13.singleRemove,
          datum = _ref13.datum,
          renderUnmatched = _ref13.renderUnmatched;

      var res;
      cov_8fog4h7k9.s[71]++;

      if (datum.isUnMatch(data)) {
        cov_8fog4h7k9.b[31][0]++;
        cov_8fog4h7k9.s[72]++;

        if (renderUnmatched) {
          cov_8fog4h7k9.b[32][0]++;
          cov_8fog4h7k9.s[73]++;
          res = renderUnmatched(data.value);
        } else {
          cov_8fog4h7k9.b[32][1]++;
          cov_8fog4h7k9.s[74]++;
          res = typeof data.value === 'string' ? (cov_8fog4h7k9.b[33][0]++, data.value) : (cov_8fog4h7k9.b[33][1]++, null);
        }
      } else {
        cov_8fog4h7k9.b[31][1]++;
        cov_8fog4h7k9.s[75]++;
        res = (cov_8fog4h7k9.b[34][0]++, data) && (cov_8fog4h7k9.b[34][1]++, render(data, raw));
      }

      cov_8fog4h7k9.s[76]++;

      if (!res) {
        cov_8fog4h7k9.b[35][0]++;
        cov_8fog4h7k9.s[77]++;
        return null;
      } else {
        cov_8fog4h7k9.b[35][1]++;
      }

      var more = (cov_8fog4h7k9.s[78]++, this.getCompressedBound());
      cov_8fog4h7k9.s[79]++;
      return (
        /*#__PURE__*/
        React.createElement(Item, Object.assign({
          key: index,
          only: more === 1
        }, options, {
          data: data,
          className: className,
          singleRemove: singleRemove,
          close: this.removeTargetNode,
          isPopover: true,
          isDisabled: datum.isDisabled(datum.getKey(data)),
          click: this.handleNodeClick,
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 232,
            columnNumber: 7
          }
        }), res)
      );
    }
  }, {
    key: "renderMore",
    value: function renderMore(list) {
      cov_8fog4h7k9.f[20]++;

      var _ref14 = (cov_8fog4h7k9.s[80]++, this.props),
          selectId = _ref14.selectId,
          size = _ref14.size,
          compressed = _ref14.compressed;

      var more = (cov_8fog4h7k9.s[81]++, this.getCompressedBound());
      cov_8fog4h7k9.s[82]++;
      return [
      /*#__PURE__*/
      React.createElement(More, {
        key: "more",
        data: list,
        className: cascaderClass(getDirectionClass('item'), 'item-compressed'),
        popoverClassName: cascaderClass('popover'),
        contentClassName: cascaderClass('result', size),
        dataId: selectId,
        showNum: more,
        compressed: compressed,
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 253,
          columnNumber: 7
        }
      })];
    }
  }, {
    key: "renderInput",
    value: function renderInput() {
      cov_8fog4h7k9.f[21]++;

      var _ref15 = (cov_8fog4h7k9.s[83]++, this.props),
          onFilter = _ref15.onFilter,
          focus = _ref15.focus,
          trim = _ref15.trim,
          bindInput = _ref15.bindInput,
          filterText = _ref15.filterText,
          multiple = _ref15.multiple,
          emptyAfterSelect = _ref15.emptyAfterSelect;

      cov_8fog4h7k9.s[84]++;
      return (
        /*#__PURE__*/
        React.createElement(Input, {
          filterText: filterText,
          ref: bindInput,
          trim: !!trim,
          multiple: multiple,
          emptyAfterSelect: emptyAfterSelect,
          key: "input.".concat(focus ? (cov_8fog4h7k9.b[36][0]++, 1) : (cov_8fog4h7k9.b[36][1]++, 0)),
          focus: true,
          onFilter: onFilter,
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 269,
            columnNumber: 7
          }
        })
      );
    }
  }, {
    key: "renderPlaceholder",
    value: function renderPlaceholder(empty) {
      cov_8fog4h7k9.f[22]++;

      var _ref16 = (cov_8fog4h7k9.s[85]++, this.props),
          focus = _ref16.focus,
          onFilter = _ref16.onFilter,
          innerTitle = _ref16.innerTitle;

      cov_8fog4h7k9.s[86]++;

      if ((cov_8fog4h7k9.b[38][0]++, focus) && (cov_8fog4h7k9.b[38][1]++, onFilter)) {
        cov_8fog4h7k9.b[37][0]++;
        cov_8fog4h7k9.s[87]++;
        return this.renderInput();
      } else {
        cov_8fog4h7k9.b[37][1]++;
      }

      cov_8fog4h7k9.s[88]++;
      return (
        /*#__PURE__*/
        React.createElement("span", {
          key: "placeholder",
          style: !empty ? (cov_8fog4h7k9.b[39][0]++, {
            display: 'none'
          }) : (cov_8fog4h7k9.b[39][1]++, undefined),
          className: classnames(inputClass('placeholder'), selectClass('ellipsis'), (cov_8fog4h7k9.b[40][0]++, innerTitle) && (cov_8fog4h7k9.b[40][1]++, inputTitleClass('hidable'))),
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 288,
            columnNumber: 7
          }
        }, this.props.placeholder, "\xA0")
      );
    }
  }, {
    key: "renderIndicator",
    value: function renderIndicator() {
      cov_8fog4h7k9.f[23]++;

      var _ref17 = (cov_8fog4h7k9.s[89]++, this.props),
          multiple = _ref17.multiple,
          showArrow = _ref17.showArrow,
          compressed = _ref17.compressed;

      cov_8fog4h7k9.s[90]++;

      if ((cov_8fog4h7k9.b[42][0]++, !showArrow) || (cov_8fog4h7k9.b[42][1]++, multiple) && (cov_8fog4h7k9.b[42][2]++, !compressed)) {
        cov_8fog4h7k9.b[41][0]++;
        cov_8fog4h7k9.s[91]++;
        return null;
      } else {
        cov_8fog4h7k9.b[41][1]++;
      }

      var showCaret = (cov_8fog4h7k9.s[92]++, !multiple); // eslint-disable-next-line

      cov_8fog4h7k9.s[93]++;
      return (
        /*#__PURE__*/
        React.createElement("a", {
          key: "indicator",
          tabIndex: -1,
          className: selectClass('indicator', multiple ? (cov_8fog4h7k9.b[43][0]++, 'multi') : (cov_8fog4h7k9.b[43][1]++, 'caret')),
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 309,
            columnNumber: 7
          }
        }, (cov_8fog4h7k9.b[44][0]++, showCaret) && (cov_8fog4h7k9.b[44][1]++,
        /*#__PURE__*/
        React.createElement(Caret, {
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 310,
            columnNumber: 23
          }
        })))
      );
    }
  }, {
    key: "renderResult",
    value: function renderResult() {
      cov_8fog4h7k9.f[24]++;

      var _ref18 = (cov_8fog4h7k9.s[94]++, this.props),
          datum = _ref18.datum,
          _ref18$value = _ref18.value,
          value = _ref18$value === void 0 ? (cov_8fog4h7k9.b[45][0]++, []) : _ref18$value,
          renderItem = _ref18.renderItem,
          renderResult = _ref18.renderResult,
          compressed = _ref18.compressed;

      var nodes = (cov_8fog4h7k9.s[95]++, ((cov_8fog4h7k9.b[46][0]++, value) || (cov_8fog4h7k9.b[46][1]++, [])).map(function (v) {
        cov_8fog4h7k9.f[25]++;
        cov_8fog4h7k9.s[96]++;
        return datum.getDataById(v);
      }));
      var render = (cov_8fog4h7k9.s[97]++, (cov_8fog4h7k9.b[47][0]++, renderResult) || (cov_8fog4h7k9.b[47][1]++, renderItem));
      cov_8fog4h7k9.s[98]++;

      if (typeof render === 'string') {
        cov_8fog4h7k9.b[48][0]++;
        var copyRender = (cov_8fog4h7k9.s[99]++, render);
        cov_8fog4h7k9.s[100]++;

        render = function render(n) {
          cov_8fog4h7k9.f[26]++;
          cov_8fog4h7k9.s[101]++;
          return n[copyRender];
        };
      } else {
        cov_8fog4h7k9.b[48][1]++;
      }

      var items = (cov_8fog4h7k9.s[102]++, this.handleNode(nodes, render));
      cov_8fog4h7k9.s[103]++;

      if ((cov_8fog4h7k9.b[50][0]++, compressed) && (cov_8fog4h7k9.b[50][1]++, items.length)) {
        cov_8fog4h7k9.b[49][0]++;
        cov_8fog4h7k9.s[104]++;
        items = this.renderMore(items);
      } else {
        cov_8fog4h7k9.b[49][1]++;
      }

      cov_8fog4h7k9.s[105]++;
      items.push(this.renderPlaceholder(items.length === 0));
      cov_8fog4h7k9.s[106]++;
      return items;
    }
  }, {
    key: "render",
    value: function render() {
      cov_8fog4h7k9.f[27]++;

      var _ref19 = (cov_8fog4h7k9.s[107]++, this.props),
          style = _ref19.style,
          _ref19$value = _ref19.value,
          value = _ref19$value === void 0 ? (cov_8fog4h7k9.b[51][0]++, []) : _ref19$value,
          compressed = _ref19.compressed,
          multiple = _ref19.multiple,
          innerTitle = _ref19.innerTitle,
          onFilter = _ref19.onFilter,
          focus = _ref19.focus;

      var empty = (cov_8fog4h7k9.s[108]++, value.length === 0);
      var result = (cov_8fog4h7k9.s[109]++, this.renderResult());
      var clearEl = (cov_8fog4h7k9.s[110]++, this.renderClear());
      var shouldCompressed = (cov_8fog4h7k9.s[111]++, (cov_8fog4h7k9.b[52][0]++, multiple) && (cov_8fog4h7k9.b[52][1]++, compressed));
      cov_8fog4h7k9.s[112]++;
      return (
        /*#__PURE__*/
        React.createElement(InputTitle, {
          className: cascaderClass('title-box'),
          titleClass: cascaderClass(getDirectionClass('title-box-title'), (cov_8fog4h7k9.b[53][0]++, shouldCompressed) && (cov_8fog4h7k9.b[53][1]++, 'title-box-title-compressed')),
          innerTitle: innerTitle,
          open: (cov_8fog4h7k9.b[54][0]++, !empty) || (cov_8fog4h7k9.b[54][1]++, onFilter) && (cov_8fog4h7k9.b[54][2]++, focus),
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 340,
            columnNumber: 7
          }
        },
        /*#__PURE__*/
        React.createElement("div", {
          ref: this.bindResult,
          className: classnames(cascaderClass(getDirectionClass('result'), (cov_8fog4h7k9.b[55][0]++, shouldCompressed) && (cov_8fog4h7k9.b[55][1]++, 'compressed'), (cov_8fog4h7k9.b[56][0]++, clearEl) && (cov_8fog4h7k9.b[56][1]++, 'result-clearable')), (cov_8fog4h7k9.b[57][0]++, innerTitle) && (cov_8fog4h7k9.b[57][1]++, inputTitleClass('item-scroll'))),
          style: style,
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 349,
            columnNumber: 9
          }
        }, result, this.renderIndicator(), clearEl))
      );
    }
  }]);

  return Result;
}(PureComponent);

Result.defaultProps = {
  value: []
};
export default Result;